export default "__VITE_ASSET__b4bdf021__"